import React from 'react';
import Reveal from './Reveal';
import Counter from './Counter';
import '../styles/stats.css';

const Stats = () => (
  <section className="section section-tight stats" aria-label="Key stats">
    <div className="stats-grid">
      <Reveal className="stat glass" delay={0}>
        <div className="stat-value"><Counter value={420.69} decimals={2} suffix="T" /></div>
        <div className="stat-label">max supply</div>
      </Reveal>
      <Reveal className="stat glass" delay={0.08}>
        <div className="stat-value"><Counter value={5} suffix="%" /></div>
        <div className="stat-label">transfer fee</div>
      </Reveal>
      <Reveal className="stat glass" delay={0.21}>
        <div className="stat-value"><Counter value={3} suffix="%" /></div>
        <div className="stat-label">removed / transfer</div>
        <div className="stat-note">descriptive only</div>
      </Reveal>
      <Reveal className="stat glass" delay={0.24}>
        <div className="stat-value stat-value--text">WAX</div>
        <div className="stat-label">blockchain</div>
      </Reveal>
    </div>
  </section>
);

export default Stats;
